(function(){
  var io=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{threshold:.15});
  var W=[],I=[],P=[];
  function init(){
    document.querySelectorAll('.cm-rv').forEach(function(e){io.observe(e)});
    document.querySelectorAll('.cm-words').forEach(function(h){
      if(!h.dataset.done){h.dataset.done=1;h.innerHTML=h.textContent.trim().split(/\s+/).map(function(w){return'<span>'+w+'</span>'}).join(' ')}
    });
    W=[].slice.call(document.querySelectorAll('.cm-words'));
    I=[].slice.call(document.querySelectorAll('.cm-im img'));
    P=[].slice.call(document.querySelectorAll('.cm-ph img'));
    sc();
  }
  function sc(){
    var vh=innerHeight,red=matchMedia('(prefers-reduced-motion:reduce)').matches;
    W.forEach(function(h){
      var s=h.querySelectorAll('span'),r=h.getBoundingClientRect(),p=(vh*.85-r.top)/(r.height+vh*.3);
      s.forEach(function(w,i){w.classList.toggle('on',red||i/s.length<p*1.15)});
    });
    if(red)return;
    I.forEach(function(i){var b=i.parentNode.parentNode.getBoundingClientRect(),c=(b.top+b.height/2-vh/2)/vh;i.style.transform='translateY('+c*-70+'px) rotate('+c*6+'deg)'});
    P.forEach(function(i){var q=i.parentNode.getBoundingClientRect();i.style.transform='scale('+(1.08-Math.min(Math.max((vh-q.top)/vh,0),1)*.08)+')'});
  }
  addEventListener('scroll',sc,{passive:true});
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();